import { DropdownStyleFn } from '@core-ui/dropdown/types/types';
import { CSSObject, Theme } from '@core-ui/react-stitch';

const getArrowSVG: DropdownStyleFn<string> = ({ theme }) => {
  const color = theme.color.inverse.b1.replace('#', '%23');
  return `url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='7' height='5' viewBox='0 0 7 5'%3E%3Cpath d='M0.000121923 1.13158L3.50012 4.5L7.00012 1.13158L6.34387 0.5L3.50012 3.23684L0.656372 0.5L0.000121923 1.13158Z' style='fill:${color};fill-rule:evenodd' /%3E%3C/svg%3E")`;
};


const getControlBeforeStyles = (theme: Theme): CSSObject => ({
  content: '""',
  background: `${getArrowSVG({ theme })} no-repeat`,
  width: '1.5rem',
  height: '2rem',
  display: 'block',
  position: 'absolute',
  right: '1px',
  top: '1px',
  backgroundPositionX: '2px',
  backgroundPositionY: '18px',
});

export default getControlBeforeStyles;
